import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SortDirection, SortFields, SortingTask } from '../config';

export interface TaskGroupsState {
  sort: SortingTask;
}

const initialState: TaskGroupsState = {
  sort: [SortFields.Date, SortDirection.Desc],
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setValues: (state, action: PayloadAction<Partial<TaskGroupsState>>) => {
      Object.assign(state, action.payload);
    },
  },
  selectors: {
    selectSort: (state) => state.sort,
  },
});

export const { setValues } = tasksSlice.actions;

export const { selectSort } = tasksSlice.selectors;

export const tasksReducer = tasksSlice.reducer;
